import React, { useState, useContext } from 'react';
import sportsApi from '../../utils/sportsApi';
import connect from '../../utils/connect';
import combineActions from '../../utils/combineActions';
import { useTranslation } from 'react-i18next';
import sendNotification from '../../actions/notifications/send';
import { Context } from '../contexts/OnboardingContext';
import { SponsorContext } from '../contexts/SponsorContext';
import { PlacementContext } from '../contexts/PlacementContext';

import PropTypes from 'prop-types';

const CustomButtons = ({ sendNotification, client, type = 'placement' }) => {
    const { t } = useTranslation('settings');
    const { rhId, structureLocked } = useContext(Context);

    const { newRequests, setNewRequests, requested, setRequested } = useContext(
        type === 'placement' ? PlacementContext : SponsorContext,
    );

    const [isSaving, setSaving] = useState(false);
    const newRequestedNames = newRequests.reduce((acc, req) => {
        const { name } = req;
        if (name && name != '') {
            acc.push(name);
        }
        return acc;
    }, []);
    const rightLengthName = newRequestedNames.every(name => name.length >= 3);

    const noNewRequestedNames = newRequestedNames.length === 0;

    const cancel = () => {
        setNewRequests([{ name: '' }]);
    };

    const save = async () => {
        setSaving(true);
        try {
            if (noNewRequestedNames) return;
            if (!rightLengthName) {
                sendNotification(
                    t('clientConfiguration.customContent.validationError', {
                        type,
                    }),
                    {
                        context: 'warning',
                    },
                );
                setSaving(false);
                return;
            }

            const payload = {
                action: 'createMultiple',
                placementNames: type === 'placement' ? newRequestedNames : null,
                sponsorNames: type === 'sponsor' ? newRequestedNames : null,
            };

            const newReqs = await sportsApi
                .url(
                    `/clients/${client.id}/rightsholders/${rhId}/${type}s/requests`,
                )
                .json(payload)
                .post()
                .json();

            const newRequested = [...requested, ...newReqs];
            setRequested(newRequested);
            setNewRequests([{ name: '' }]);
            setSaving(false);
        } catch (e) {
            setSaving(false);
            // eslint-disable-next-line no-console
            console.log(e);
        }
    };

    return (
        <div className="gds-flex__item gds-flex__item--grow-0">
            <div className="gds-flex__item gds-flex__item--grow-0">
                <button
                    type="button"
                    className="gds-button gds-button--sm gds-button--default -m-r-1"
                    onClick={cancel}
                    disabled={structureLocked || isSaving}
                >
                    {t('clientConfiguration.onboarding.cancel')}
                </button>

                <button
                    type="button"
                    className="gds-button gds-button--sm gds-button--secondary"
                    onClick={save}
                    disabled={structureLocked || noNewRequestedNames || isSaving}
                >
                    {t('clientConfiguration.onboarding.submit')}
                </button>
            </div>
        </div>
    );
};

CustomButtons.propTypes = {
    client: PropTypes.object,
    sendNotification: PropTypes.func,
    type: PropTypes.string,
};

export default connect(
    ['client'],
    combineActions({
        sendNotification,
    }),
)(CustomButtons);
